import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const TrainingsService = {
    list: async (filters) => axios.post(API_URL + "/trainings/list", filters).then(({data}) => data).catch((err) => { throw err }),

    users: async (search = "") => axios.get(API_URL + "/trainings/users", {params: {search}}).then(({data}) => data).catch((err) => { throw err }),

    importTemplateOptions: async () => axios.get(API_URL + "/trainings/users/import/template-options").then(({data}) => data).catch((err) => { throw err }),

    importUsers: async (users, createMissing = false) => axios.post(API_URL + "/trainings/users/import", {users, create_missing: createMissing}).then(({data}) => data).catch((err) => { throw err }),

    projects: async () => axios.get(API_URL + "/projects/list").then(({data}) => data).catch(err => { throw err }),

    getById: async (id) => axios.get(API_URL + "/trainings/" + id).then(({data}) => data).catch((err) => { throw err }),

    generateCertificates: async (id) => axios.post(API_URL + "/trainings/" + id + "/certificates/generate").then(({data}) => data).catch((err) => { throw err }),

    generateUserCertificate: async (id, userId) => axios.post(API_URL + "/trainings/" + id + "/certificates/users/" + userId + "/generate").then(({data}) => data).catch((err) => { throw err }),

    certificateStatus: async (id) => axios.get(API_URL + "/trainings/" + id + "/certificates/status").then(({data}) => data).catch((err) => { throw err }),

    downloadCertificates: async (id) => axios.get(API_URL + "/trainings/" + id + "/certificates/download", {
        responseType: "blob"
    }).then((response) => response).catch((err) => { throw err }),

    sendCertificates: async (id) => axios.post(API_URL + "/trainings/" + id + "/certificates/send").then(({data}) => data).catch((err) => { throw err }),

    downloadUserCertificate: async (id, userId) => axios.get(API_URL + "/trainings/" + id + "/certificates/users/" + userId + "/download", {
        responseType: "blob"
    }).then((response) => response).catch((err) => { throw err }),

    sendUserCertificate: async (id, userId) => axios.post(API_URL + "/trainings/" + id + "/certificates/users/" + userId + "/send").then(({data}) => data).catch((err) => { throw err }),

    create: async (model) => axios.post(API_URL + "/trainings", model).then(({data}) => data).catch((err) => { throw err }),

    edit: async (model, id) => axios.post(API_URL + "/trainings/" + id, model).then(({data}) => data).catch((err) => { throw err }),

    delete: async (id) => axios.delete(API_URL + "/trainings/" + id).then(({data}) => data).catch((err) => { throw err }),
};

export default TrainingsService;
